import { BaseConnector } from './baseConnector';

class SubjectAreaConnector extends BaseConnector {
  getSubjectAreas() {
    var url = `${this.baseApiUrl}/subjectArea`;
    return this.authFetch(url);
  }

  getSubjectArea(subjectAreaId) {
    var url = `${this.baseApiUrl}/subjectArea/${subjectAreaId}`;
    return this.authFetch(url);
  }

  createSubjectArea(subjectArea) {
    var url = `${this.baseApiUrl}/subjectArea`;
    return this.authPost(url, subjectArea);
  }

  updateSubjectArea(subjectAreaId, subjectArea) {
    var url = `${this.baseApiUrl}/subjectArea/${subjectAreaId}`;
    return this.authPatch(url, subjectArea);
  }

  deleteSubjectArea(subjectAreaId) {
    var url = `${this.baseApiUrl}/subjectArea/${subjectAreaId}`;
    return this.authDelete(url);
  }
}

export { SubjectAreaConnector };
